import { Link } from 'react-aria-components';

import { MedrecruitLogo } from '#/shared/components/MedrecruitLogo';
import { appConfig } from '#/shared/config/AppConfig';
import { focusRingClassName } from '#/shared/utils/domHelper';

import { Container } from './Container';

const MEDRECRUIT_BASE_URL = appConfig.medrecruitWebBaseUrl;

const FOOTER_LINKS = [
  { href: MEDRECRUIT_BASE_URL + '/privacy-policy', label: 'Privacy' },
  {
    href: MEDRECRUIT_BASE_URL + '/terms-and-conditions',
    label: 'Terms and conditions',
  },
  { href: `mailto:${appConfig.feedback.email}`, label: 'Contact us' },
];

export function Footer() {
  return (
    <footer className="flex items-center justify-between p-md bg-surface-l0 py-xxl">
      <Container className="gap-md">
        <div className="flex flex-col tablet-portrait:flex-row justify-between items-center gap-xl">
          <MedrecruitLogo medrecruitWebBaseUrl={appConfig.medrecruitWebBaseUrl} />
          <nav className="flex flex-col tablet-portrait:flex-row items-center justify-center tablet-portrait:justify-end gap-xl tablet-portrait:gap-xxl w-full">
            {FOOTER_LINKS.map(link => (
              <Link
                key={link.href}
                href={link.href}
                className={`text-18 font-400 leading-20 text-on-surface hover:text-primary-shade hover:underline text-center tablet-portrait:text-right ${focusRingClassName}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="flex self-center tablet-portrait:self-end">
          <span className="text-16 font-400 leading-20 text-on-surface-variant text-center tablet-portrait:text-right">
            © {new Date().getFullYear()} Medrecruit. All rights reserved.
          </span>
        </div>
      </Container>
    </footer>
  );
}
